module.exports = __webpack_public_path__ + "static/media/AvenirNext-BoldItalic.7ae62d11.woff";